'use client';

import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';
import { twMerge } from 'tailwind-merge';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.TabsList>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.TabsList>
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <TabsPrimitive.TabsList
      className={twMerge('flex bg-retail-gray-100 rounded-xl p-1', className)}
      {...rest}
      ref={ref}
    />
  );
});

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.TabsTrigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.TabsTrigger>
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <TabsPrimitive.TabsTrigger
      className={twMerge(
        'px-4 py-3 h-12 rounded-lg data-[state=active]:bg-retail-primary-600 data-[state=active]:text-white text-retail-text-secondary bg-retail-gray-100 flex items-center justify-center text-lg font-semibold focus:outline-none',
        className
      )}
      {...rest}
      ref={ref}
    />
  );
});

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.TabsContent>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.TabsContent>
>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <TabsPrimitive.TabsContent
      className={twMerge('', className)}
      {...rest}
      ref={ref}
    />
  );
});

Tabs.displayName = TabsPrimitive.Root.displayName;

TabsTrigger.displayName = TabsPrimitive.TabsTrigger.displayName;

TabsList.displayName = TabsPrimitive.TabsList.displayName;

TabsContent.displayName = TabsPrimitive.TabsContent.displayName;

export { Tabs, TabsContent, TabsList, TabsTrigger };
